/**
 * @param {string|string[]} data
 * @param {string|number} queryParam
 * @returns {Boolean}
 */
const isFSEnabled = (data, queryParam) =>
  data === '*' || data?.includes(queryParam);

export default isFSEnabled;
